module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-modal', {
    staticClass: "c-modal-video"
  }, [_c('div', {
    staticClass: "c-modal-video__bg u-absolute u-pos-tl u-fit",
    on: {
      "click": _vm._close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-modal-video__content u-absolute"
  }, [_c('div', {
    staticClass: "u-absolute u-pos-tl u-fit"
  }, [(_vm.type === 'youtube') ? _c('app-youtube', {
    staticClass: "u-block u-absolute u-fit u-pos-tl",
    attrs: {
      "id": _vm.id,
      "autoplay": true,
      "mute": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'jwplayer') ? _c('div', {
    staticClass: "c-modal-video__jwplayer u-block u-absolute u-fit u-pos-tl",
    attrs: {
      "id": "modal-video-jwplayer"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('a', {
    staticClass: "c-modal-video__close u-absolute",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm._close($event)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03bb50ac"}!./src/scripts/components/app-modal-video/template.html
// module id = 880
// module chunks = 0